export default {
	AGENDA: 'Dashboard/AgendaWidget',
	ACTIVITIES: 'Dashboard/ActivitiesWidget',
	CASES: 'Dashboard/CasesWidget',
	APPOINTMENTS: 'Dashboard/AppointmentsWidget',
	PROFILE: 'Dashboard/ProfileWidget',
	NAVIGATION: 'Generic/Navigation/Links',
	MU_NAVIGATION: 'Generic/Navigation/Links_MU',
	LOGOUT: 'Generic/Navigation/Logout',
	GOBACKNAVIGATION: 'Generic/Navigation/GoBack',
	UNITS: 'Generic/Navigation/Units',
	CHAT: 'V2__Chat/Chat',
	HEADER: 'V2__Chat/Header',
	SELECT_CLIENT: 'Generic/Navigation/ClientSelection',
	SELECT_BACKOFFICE: 'Generic/Navigation/SelectBackoffice',

	/**NHS Widgets Dashboard */
	WELCOME: 'Journals/NHS/WelcomeWidget',
	WEIGHT: 'Journals/NHS/WeightWidget',
	FOOD: 'Journals/NHS/FoodWidget',
	MOOD: 'Journals/NHS/MoodWidget',
	EXERCISE: 'Journals/NHS/ExerciseWidget',
	DAILYREPORT: 'Journals/NHS/DailyReportWidget',
	MEETING: 'Journals/NHS/NextMeetingWidget',
	COMMUNITY: 'Journals/NHS/CommunityWidget',
	LIBRARY: 'Journals/NHS/LibraryWidget',
	MYFILES: 'Journals/NHS/Myfiles',
	GOAL: 'Journals/NHS/GoalsWidget',
	TICKETS_REFERRALS: 'Journals/NHS/TicketsReferrals',

  /**NYN Widgets Dashboard */
	MEETING_NYN: 'Journals/NYN/NextMeetingWidget',
	COMMUNITY_NYN: 'Journals/NYN/CommunityWidget',
	MYFILES_NYN: 'Journals/NYN/Myfiles',
  ACTIVITY_NYN: 'Journals/NYN/ActivityWidget',

	/**NHS Journals Widgets */
	/**Smart Goals */
	GOBACKSMARTGOALS: 'Journals/SmartGoals/GoBack',
	SETWEIGHTGOALS: 'Journals/SmartGoals/WeightGoals',
	SETQUALITYGOALS: 'Journals/SmartGoals/QualityGoals',
	/**Weight Widgets */
	GOBACKWEIGHT: 'Journals/Weight/GoBack',
	UPDATEWEIGHT: 'Journals/Weight/Weight',
	LOGSWEIGHT: 'Journals/Weight/Logs',
	/**Food Widgets */
	GOBACKFOOD: 'Journals/Food/GoBack',
	UPDATEFOOD: 'Journals/Food/Food',
	LOGSFOOD: 'Journals/Food/FoodLogs',
	/**Mood Widgets */
	GOBACKMOOD: 'Journals/Mood/GoBack',
	UPDATEMOOD: 'Journals/Mood/Mood',
	LOGSMOOD: 'Journals/Mood/MoodLogs',
	/**Exercise Widgets */
	GOBACKEXERCISE: 'Journals/Exercise/GoBack',
	UPDATEEXERCISE: 'Journals/Exercise/Exercise',
	LOGSEXERCISE: 'Journals/Exercise/ExerciseLogs',
	/**Daily Report Widgets */
	GOBACKDAILYREPORT: 'Journals/DailyReport/GoBack',
	DAILYREPORTS: 'Journals/DailyReport/DailyReport',
	DAILYREPORTFOODQUESTIONNAIRE: 'Journals/DailyReport/DailyReportFoodQuestionnaire',
	DAILY_LOGS_BUTTONS: 'Journals/DailyReport/DailyLogsButtons',
	/**Community Widgets */
	GOBACKCOMMUNITY: 'Journals/Community/GoBack',
	COMMUNITYDETAILS: 'Journals/Community/Community',
	ACTIVITYLIST: 'Journals/Community/ActivityList',
	ACTIVITY_SUMMARY: 'Journals/Community/ActivitySummary',
	/**Library Widgets */
	GOBACKLIBRARY: 'Journals/Library/GoBack',
	LIBRARYFILE: 'Journals/Library/LibraryLogs',
	/**Files Widgets */
	GOBACKFILES: 'Journals/Files/GoBack',
	MYFILESTICKET: 'Journals/Files/FilesLogs',
	/**Dashboard */
	DASHBOARD: 'Dashboard/Dashboard',

	/**TICKET */
	TICKET_OVERVIEW: 'Tickets/Layout',
	GOBACKFILETAGS: 'Tickets/TicketTags/GoBack',
	TAGSFILE: 'Tickets/TicketTags/TagsLogs',
	TICKET_REFERRAL_FORM: 'Tickets/Referral/ReferralForm',
	TICKET_PATIENT_INFO: 'Tickets/Referral/PatientInfo',
	TICKET_REFERRAL: 'Tickets/Referral/Referral',
	REFERRAL_EDIT: 'Tickets/Referral/ReferralEdit',
	LAYOUT_CHAT: 'Tickets/LayoutChat',

	/**SEARCH */
	ANALYTIC_TICKETS_LOGS: 'Analytic/AnalyticTicketsLogs',
	ANALYTIC_TICKET_LOGS: 'Analytic/AnalyticTicketLogs',

	/**INVITE */
	INVITE_OVERVIEW: 'Invite/Overview',
	INVITE_SINGLE_FORM: 'Tickets/Invite/InviteSingleForm',
	INVITE_FUNC_FORM: 'Tickets/Invite/InviteForm_Func',
	FORM_INVITE: 'Tickets/Invite_OPTI/InviteSingleForm_v1',

	/**GENERIC */
	PAGE_TITLE: 'Generic/PageTitle',
	SUPPORT: 'Generic/Support',

	/**MODAL */
	EVENT_CANCEL: 'Generic/CancelEvent',
	PRECALL: 'VideoConference/PrecallWidget',

	/**QUESTIONNAIRES */
	SURVEY: 'Surveys/Survey',
	SURVEYS: 'Surveys/Surveys',
  TICKET_QUESTIONNAIRE: 'Tickets/Overview/Questionnaires',   /**OLD QUESTIONNAIRE SYSTEM */
  OPTI_SURVEY_PREVIEW: 'Surveys/SurveyOptiPreview',

	/**STATISTIC */
	STATISTIC_OVERVIEW: 'Statistics/Overview',
	STATISTIC_CONTACTS: 'Statistics/StatisticContacts',
	STATISTIC_CONTACTS_INTERVAL: 'Statistics/StatisticContactsInterval',
	STATISTIC_CONTACTS_CATEGORY: 'Statistics/StatisticContactsCategory',
	STATISTIC_CONTACTS_CATEGORY_GROUP: 'Statistics/StatisticContactsCategoryGroup',
	STATISTIC_CONTACTS_TYPE: 'Statistics/StatisticContactsType',
	STATISTIC_CONTACTS_TAG_GROUPS: 'Statistics/StatisticContactsTagGroup',
	STATISTIC_TICKETS_REFERRAL: 'Statistics/StatisticTicketsReferral',
	STATISTIC_CONTACTS_GENDER: 'Statistics/StatisticContactsGender',
	STATISTIC_CONTACTS_PRONOUN: 'Statistics/StatisticContactsPronoun',

	/**QUESTIONNAIRES */
	FREETIME_FORM: 'Users/MyPages/Calendar/FreeTime',

	/**ADMIN */
	CLIENT_MANAGEMENT: 'Admin/ClientMangement/Installations',
	USER_MANAGEMENT: 'Admin/ClientMangement/Users',
	SERVICES: 'Admin/ClientMangement/Services',
	ORGANIZATION: 'Admin/ClientMangement/Organization',
	CLIENT_ORGANIZATION: 'Admin/ClientMangement/ClinicManagement',
	ORGANIZATIONS: 'Admin/ClientMangement/OrganizationManagement',
	USER_INVITATIONS: 'Admin/ClientMangement/UserInvitations',

	/**CLIENTS */
	REFERRAL_SEARCH_CLIENT: 'Tickets/Referral/ReferralSearchClient',
	/**USER */
	USER_FORM: 'Users/UserForm',
	USER_TICKETS: 'Tickets/List/UserCases',

	/**ACTIVITIES */
	ACTIVITY_PARTICIPANTS_TICKETS_CLOSE: 'Activities/Participants/TicketsClose',

	/**KIND */
	/**LEFT SIDE BAR */
	SIDE_BAR_LEFT_HEADER: 'Generic/Navigation/Kind/Header',
	SIDE_BAR_LEFT_OVERVIEW: 'Generic/Navigation/Kind/Overview',
	SIDE_BAR_LEFT_OVERVIEW_PATIENT: 'Generic/Navigation/Kind/OverviewPatient',
	SIDE_BAR_LEFT_USER: 'Generic/Navigation/Kind/User',
	SIDE_BAR_LEFT_USER_NAVIGATION: 'Generic/Navigation/Kind/UserNavigation',

	/**CHAT FEATURE*/
	CONTACTS_OVERVIEW: 'Tickets/Layout_Kind/Layout',
	BROADCAST_MESSAGE_LIST: 'Chat/BroadcastMessage',
	BROADCAST_MESSAGE_INPUT: 'Chat/BroadcastMessageInput',
	BROADCAST_MESSAGE_ACTIONS: 'Chat/BroadcastMessageActions',
	CHAT_USER_INFO: 'V2__Chat/KindHeaderInfo',
	CHAT_USER_CARETEAM: 'V2__Chat/KindHeaderCareTeam',
	CHAT_USER_NOTES: 'V2__Chat/KindHeaderNotes',
	CHAT_USER_MANAGE_NOTES: 'V2__Chat/KindHeaderManageNotes',
	CHAT_TICKET_ACTIONS: 'Chat/ChatTicketActions',
	ASSIGN_SCHEDULER: 'Chat/AssignScheduler',
	GENERATE_TEMPLATE: 'Chat/GenerateTemplate',
	ASSIGN_TICKET_SURVEY: 'Tickets/AssignTicketSurvey',
  SCHEDULER_CHAT_MESSAGE: 'Chat/SchedulerChatMessage',
  SCHEDULER_CHAT_MESSAGE_LIST: 'V2__Chat/SchedulerChatMessageList',

	/**SCHEDULERS */
	SCHEDULERS_LIST: 'Admin/Schedulers/List',
	SCHEDULER_FORM: 'Admin/Schedulers/SchedulerForm',

	/**NAVBARS */
	DEFAULT_NAVBAR: 'Layout/NavBars/DefaultNavBar',
	KIND_NAVBAR: 'Layout/NavBars/KindNavBar',
	KIND_BOTTOM_SLIDER_NAVBAR_MENU: 'Layout/NavBars/Widgets/KindPlusMenu',
	KIND_BOTTOM_SLIDER_ARTICLE_MENU: 'Layout/NavBars/Widgets/KindPlusArticleMenu',

	/**ARTICLES */
	ARTICLES_MAIN: 'Articles/Articles',
	ARTICLES_MANAGE: 'Articles/ArticleManage',
	ARTICLE_VIEW: 'Articles/ArticleView',
	FILE_MANAGE: 'Articles/FileManage',

	/**EVENTSFORM */
	EVENT_FORM: 'Users/MyPages/Calendar/EventForm',

	/**VIDEO CALL */
	TICKET_VIDEO_CONFERENCE: 'Tickets/Video/TicketVideoConference',

	/**BOOKING WIDGET */
	BOOKING_OVERVIEW: 'Meetings/BookingMeeting',
	BOOKING_CALENDAR: 'Meetings/BookingCalendar',
};
